/**
 * Public job-application position slugs (URL query + form + mutation input).
 * CRM stores the Polish/English labels from `JOB_APPLICATION_SLUG_TO_LABEL`, not the slugs.
 */
export const JOB_APPLICATION_POSITION_SLUGS = [
  'mentor',
  'mid-full-stack-engineer',
  'junior-full-stack-engineer',
  'ui-ux-designer',
  'marketing-specialist'
] as const

export type JobApplicationPositionSlug = (typeof JOB_APPLICATION_POSITION_SLUGS)[number]

/**
 * Stable CRM select option strings for `Aplikacja o pracę` → `position`.
 * Keep in sync with `CRM_JOB_APPLICATION_EVENT_TYPE.fields.position.options`
 * (crm/system-event-types.ts imports this list).
 */
export const JOB_APPLICATION_POSITION_LABELS = [
  'Mentor',
  'Mid Full Stack Engineer',
  'Junior Full Stack Engineer',
  'UI/UX Designer',
  'Specjalista ds. Marketingu'
] as const

export type JobApplicationPositionLabel = (typeof JOB_APPLICATION_POSITION_LABELS)[number]

export const JOB_APPLICATION_SLUG_TO_LABEL = {
  mentor: 'Mentor',
  'mid-full-stack-engineer': 'Mid Full Stack Engineer',
  'junior-full-stack-engineer': 'Junior Full Stack Engineer',
  'ui-ux-designer': 'UI/UX Designer',
  'marketing-specialist': 'Specjalista ds. Marketingu'
} as const satisfies Record<JobApplicationPositionSlug, JobApplicationPositionLabel>

/** Polish short labels for marketing UI (listbox). Safe to reword independently of CRM. */
export const JOB_APPLICATION_POSITION_LABELS_PL: Record<JobApplicationPositionSlug, string> = {
  mentor: 'Mentor',
  'mid-full-stack-engineer': 'Mid Full Stack Engineer',
  'junior-full-stack-engineer': 'Junior Full Stack Engineer',
  'ui-ux-designer': 'UI/UX Designer',
  'marketing-specialist': 'Specjalista ds. Marketingu'
}
